import { Reducer } from "redux";

import { RelationshipActionDispatchTypes } from "../constants/Patient";
import { RelationshipMasterResponse } from "../models/Api/Patient";
import { RelationshipDispatchTypes } from "../models/DispatchTypes/Patient";
import { setLocalStorageData } from "../utils";

export const initialState: RelationshipMasterResponse = {
  loading: false,
  response: [],
};

const RelationshipReducer: Reducer<
  RelationshipMasterResponse,
  RelationshipDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case RelationshipActionDispatchTypes.GET_RELATIONSHIP_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case RelationshipActionDispatchTypes.GET_RELATIONSHIP_SUCCESS: {
      setLocalStorageData(
        RelationshipActionDispatchTypes.GET_RELATIONSHIP_SUCCESS,
        action.response
      );
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case RelationshipActionDispatchTypes.GET_RELATIONSHIP_ERROR: {
      return initialState;
    }
  }
  return state;
};

export default RelationshipReducer;
